export enum IconColors {
  BRAND1 = 'brand-1',
  BRAND2 = 'brand-2',
  WHITE = 'white',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  HOVER = 'hover',
  ERROR = 'error'
}
